/*
The function will be executed immediately, 
but the next call will be ignored until at least 1000ms (1 second) has passed. 
The { trailing: false } option ensures that if additional calls to handleActivity 
happen within that time frame, they will be ignored, and there won't be a 
"trailing" execution when the time limit ends.
*/

export default function throttle<T extends (...args: unknown[]) => unknown>(
  func: T,
  limit: number,
  options: { trailing?: boolean } = {},
): (...args: Parameters<T>) => void {
  let lastRan: number | undefined;
  const trailing = options.trailing === undefined ? true : options.trailing;

  return function (this: unknown, ...args: Parameters<T>) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this;

    if (!lastRan) {
      func.apply(context, args); // Call the function immediately
      lastRan = Date.now();
    } else if (Date.now() - lastRan >= limit) {
      if (!trailing) {
        lastRan = Date.now();
        return;
      }
      func.apply(context, args);
      lastRan = Date.now();
    }
  };
}
